import React from "react"
import ReactDOM from "react-dom"
import {createStore, combineReducers, compose, applyMiddleware} from "redux"

import {Provider} from "react-redux"
import thunk from "redux-thunk"

import {
  ConnectedRouter,
  routerReducer,
  routerMiddleware
} from "react-router-redux"
import App from "./App"
import AuthReducer from "./reducers/AuthReducer"
import FlashMessagesReducer from "./reducers/FlashMessagesReducer"

import {setCurrentUserFromLocalStorage} from "~/actions/authActions"
import ShelfApi from "~/utils/ShelfApi.js"
import history from "~/history.js"

// import i18n (needs to be bundled ;))
import "./i18n"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  combineReducers({
    auth: AuthReducer,
    flash: FlashMessagesReducer,
    router: routerReducer
  }),
  composeEnhancers(applyMiddleware(thunk, routerMiddleware(history)))
)

if (localStorage.accessToken) {
  ShelfApi.loadConfiguration()
  store.dispatch(setCurrentUserFromLocalStorage())
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
)

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js